import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface AvatarsItemProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const AvatarsItemComponent: React.FC<AvatarsItemProps> = ({
  children,
  style,
}) => {
  return <div style={style}>{children}</div>;
};

export const AvatarsItem: React.FC<AvatarsItemProps> = (
  props: AvatarsItemProps
) => {
  const Component = useCustomComponent({
    componentName: 'AvatarsItem',
    Component: AvatarsItemComponent,
  });

  return <Component {...props} />;
};
